import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { sendFrontAction } from '../../services/api';
import './GetOffer.css';

const STATIC_OPTIONS = [
    { value: 'other', label: 'Другой' },
    { value: 'undecided', label: 'Пока выбираю' },
];

const PAYMENT_OPTIONS = [
    'Полная оплата',
    'Рассрочка',
    'Рассматриваю оба варианта',
];

const GetOffer = () => {
    const [searchParams] = useSearchParams();
    const modelId = searchParams.get('model_id');
    const carType = searchParams.get('type') || 'new';
    const isLeasing = searchParams.get('les') === '1';

    const [carOptions, setCarOptions] = useState(STATIC_OPTIONS);

    const [form, setForm] = useState({
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        interested_car: '',
        custom_car_name: '',
        payment_method: '',
        comment: '',
    });
    const [status, setStatus] = useState('idle');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        sendFrontAction('get_offer', {}, 'GET')
            .then((data) => {
                if (data && data.success && Array.isArray(data.data)) {
                    const dynamicOptions = data.data.map((car) => ({
                        value: `${car.type}_${car.id}`,
                        label: car.name,
                    }));
                    setCarOptions([...dynamicOptions, ...STATIC_OPTIONS]);
                }
            })
            .catch((err) => {
                console.error('Не удалось загрузить список авто для рассрочки:', err);
            });
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');
        setErrorMessage('');

        try {
            const data = await sendFrontAction('get_offer', {
                model_id: modelId,
                type: carType,
                leasing: isLeasing,
                ...form,
            }, 'POST');

            if (data.success) {
                setStatus('success');
            } else {
                setStatus('error');
                setErrorMessage(data.message || 'Не удалось отправить заявку');
            }
        } catch (err) {
            setStatus('error');
            setErrorMessage(err.message || 'Не удалось установить соединение с сервером');
        }
    };

    if (status === 'success') {
        return (
            <div className="get-offer-container">
                <div className="get-offer-success">
                    <h2>Спасибо!</h2>
                    <p>Ваша заявка отправлена. Мы свяжемся с вами в ближайшее время.</p>
                    <Link to={`/catalog/${carType}`} className="get-offer-back-link">‹ Вернуться в каталог</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="get-offer-container">
            <Link to={`/catalog/${carType}`} className="get-offer-back-link">‹ Назад</Link>

            <h1 className="get-offer-title">Получите персональное предложение на BMW</h1>
            <p className="get-offer-subtitle">Заявка на приобретение автомобиля</p>

            <form className="get-offer-form" onSubmit={handleSubmit}>
                <div className="get-offer-field">
                    <label>Имя *</label>
                    <input type="text" name="first_name" value={form.first_name} onChange={handleChange} required />
                </div>

                <div className="get-offer-field">
                    <label>Телефон *</label>
                    <input
                        type="tel"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        placeholder="+998 XX XXX XX XX"
                        required
                    />
                </div>

                <div className="get-offer-field">
                    <label>Какой автомобиль вас интересует?</label>
                    <select name="interested_car" value={form.interested_car} onChange={handleChange}>
                        <option value="">Выберите вариант</option>
                        {carOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                    </select>
                </div>

                {form.interested_car === 'other' && (
                    <div className="get-offer-field">
                        <label>Укажите модель</label>
                        <input
                            type="text"
                            name="custom_car_name"
                            value={form.custom_car_name}
                            onChange={handleChange}
                            placeholder="Например: BMW M5"
                        />
                    </div>
                )}

                <div className="get-offer-field">
                    <label>Способ приобретения</label>
                    <div className="get-offer-checkbox-group">
                        {PAYMENT_OPTIONS.map((option) => (
                            <label key={option} className="get-offer-checkbox-row">
                                <input
                                    type="radio"
                                    name="payment_method"
                                    value={option}
                                    checked={form.payment_method === option}
                                    onChange={handleChange}
                                />
                                <span>{option}</span>
                            </label>
                        ))}
                    </div>
                </div>

                <div className="get-offer-field">
                    <label>Комментарий (необязательно)</label>
                    <textarea
                        name="comment"
                        value={form.comment}
                        onChange={handleChange}
                        rows={4}
                        placeholder="Например: интересует цвет, комплектация, сроки поставки"
                    />
                </div>

                <div className="get-offer-consent">
                    <input type="checkbox" required id="consent" />
                    <label htmlFor="consent">Я согласен на обработку персональных данных</label>
                </div>

                {status === 'error' && <p className="get-offer-error">{errorMessage}</p>}

                <button type="submit" className="get-offer-submit" disabled={status === 'sending'}>
                    {status === 'sending' ? 'Отправка...' : 'Получить предложение'}
                </button>
            </form>
        </div>
    );
};

export default GetOffer;